module.exports = __webpack_public_path__ + "img/point.1bb49849.svg";